import { Injectable, Inject, forwardRef } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Ng2ImgMaxService } from 'ng2-img-max';
var ImgCropService = /** @class */ (function () {
    function ImgCropService(ng2ImgMaxService) {
        this.ng2ImgMaxService = ng2ImgMaxService;
    }
    ImgCropService.prototype.cropImage = function (file, toWidth, toHeight, startX, startY) {
        var _this = this;
        if (startX === void 0) { startX = 0; }
        if (startY === void 0) { startY = 0; }
        var croppedImageSubject = new Subject();
        if (file.type !== "image/jpeg" && file.type !== "image/png") {
            // END OF CROPPING
            setTimeout(function () {
                croppedImageSubject.error({ croppedFile: file, reason: "File provided is neither of type jpg nor of type png.", error: "INVALID_EXTENSION" });
            }, 0);
            return croppedImageSubject.asObservable();
        }
        var cvs = document.createElement('canvas');
        var ctx = cvs.getContext('2d');
        var img = new Image();
        img.onload = function () {
            _this.ng2ImgMaxService.getEXIFOrientedImage(img).then(function (orientedImg) {
                window.URL.revokeObjectURL(img.src);
                cvs.width = toWidth;
                cvs.height = toHeight;
                ctx.drawImage(orientedImg, startX, startY, toWidth, toHeight, 0, 0, toWidth, toHeight);
                var imageData = ctx.getImageData(0, 0, orientedImg.width, orientedImg.height);
                var useAlpha = true;
                if (file.type === "image/jpeg" || (file.type === "image/png" && !_this.isImgUsingAlpha(imageData))) {
                    //image without alpha
                    useAlpha = false;
                    ctx = cvs.getContext('2d', { 'alpha': false });
                    ctx.drawImage(orientedImg, startX, startY, toWidth, toHeight, 0, 0, toWidth, toHeight);
                }
                cvs.toBlob(function (blob) {
                    var newFile = _this.generateResultFile(blob, file.name, file.type, new Date().getTime());
                    // END OF CROPPING
                    croppedImageSubject.next(newFile);
                }, useAlpha ? "image/png" : "image/jpeg");
            });
        };
        img.src = window.URL.createObjectURL(file);
        return croppedImageSubject.asObservable();
    };
    ImgCropService.prototype.isImgUsingAlpha = function (imageData) {
        for (var i = 0; i < imageData.data.length; i += 4) {
            if (imageData.data[i + 3] !== 255) {
                return true;
            }
        }
        return false;
    };
    ImgCropService.prototype.generateResultFile = function (blob, name, type, lastModified) {
        var resultFile = new Blob([blob], { type: type });
        return this.blobToFile(resultFile, name, lastModified);
    };
    ImgCropService.prototype.blobToFile = function (blob, name, lastModified) {
        var file = blob;
        file.name = name;
        file.lastModified = lastModified;
        //Cast to a File() type
        return file;
    };
    ImgCropService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    ImgCropService.ctorParameters = function () { return [
        { type: Ng2ImgMaxService, decorators: [{ type: Inject, args: [forwardRef(function () { return Ng2ImgMaxService; }),] }] }
    ]; };
    return ImgCropService;
}());
export { ImgCropService };
//# sourceMappingURL=img-crop.service.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-img-tools/dist/src/img-crop.service.js
// module id = ./node_modules/ng2-img-tools/dist/src/img-crop.service.js
// module chunks = 0